// NOTE: jquery_global_setup を先にインポートすることで window.jQuery を jquery-ui より前に設定する
// esbuild は import をホイストするため、ファイル先頭でインポートした jquery_global_setup が
// 後続の jquery-ui より先にバンドル内で実行されることを保証する
import "./jquery_global_setup";

import "jquery-ui-dist/jquery-ui";
// NOTE: jquery-ui-rails gemから取得したロケールファイルをローカルに配置
import "../../../assets/javascripts/lib/jquery-ui-datepicker-ja";
import "slick-carousel";

/* ------------------------------------------------------------------
# NOTE:
# jQueryのready関数をオーバーライドして、特定のコンテキストやセレクタが指定された場合でも、適切にコールバック関数を実行できるようにしている。
# this.contextやthis.selectorが存在する場合、それぞれの要素に対してコールバック関数を適用する。
--------------------------------------------------------------------- */
(function ($) {
  const { ready } = $.fn;
  // eslint-disable-next-line no-param-reassign
  $.fn.ready = function (fn) {
    if (this.context === undefined) {
      // The $().ready(fn) case.
      ready(fn);
    } else if (this.selector) {
      ready(
        $.proxy(function () {
          $(this.selector, this.context).each(fn);
        }, this)
      );
    } else {
      ready(
        $.proxy(function () {
          $(this).each(fn);
        }, this)
      );
    }
  };
})(window.jQuery);
